import PubSub from 'pubsub-js';
import { listen } from 'quicklink';
import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const preventDefault = (ev) => {
  ev.preventDefault();
};
const common = {
  init() {
    // because this is the only way to reference it in removeEventList...
    this.destroyBinded = this.destroy.bind(this);
    this.resetAnimsBinded = this.resetSlideAnims.bind(this);
    this.lscrollUpdateBinded = this.lscrollUpdate.bind(this);

    console.log('Common init');

    this.setUpListeners();
    // this.setUpSmoothScroll();
    // this.setUpSlideAnims();
    this.playTheSplash();
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionStart', this.destroyBinded);
    PubSub.subscribe('common.resetSlideAnims', this.resetAnimsBinded);

    // quicklink init
    listen();
  },

  resetSlideAnims() {
    this.destroySlideAnims();
    this.setUpSlideAnims();
  },

  setUpSmoothScroll() {
    const that = this;
    const isMobile = window.innerWidth <= 767;

    if (!this.lscroll && !isMobile) {
      this.lscroll = new LocomotiveScroll({
        el: document.getElementById('app'),
        smooth: true,
        initPosition: {x: 0, y: 0},
        reloadOnContextChange: true,
        resetNativeScroll: true,
        smartphone: {
          smooth: false
        }
      });

      this.lscroll.on('scroll', ScrollTrigger.update);

      ScrollTrigger.scrollerProxy('#app', {
        scrollTop(value) {
          return arguments.length
            ? that.lscroll.scrollTo(value, 0, 0)
            : that.lscroll.scroll.instance.scroll.y;
        },

        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          };
        },

        pinType: document.getElementById('app').style.transform
          ? 'transform'
          : 'fixed'
      });

      ScrollTrigger.addEventListener('refresh', this.lscrollUpdateBinded);

      ScrollTrigger.refresh();

      setTimeout(() => {
        this.lscrollUpdate();
      }, 1000);
    } else if (!isMobile) {
      this.lscroll.init();

      setTimeout(() => {
        this.lscrollUpdate();
      }, 1000);
    }
  },

  lscrollUpdate() {
    if (this.lscroll && this.lscroll.update) {
      this.lscroll.update();
    }
  },

  setUpSlideAnims() {
    console.log('Setting up slide in animations');

    ScrollTrigger.batch(
      '.slide-in,'
      + ' .text-in > p,'
      + ' .text-in > h1,'
      + ' .text-in > h2,'
      + ' .text-in > h3,'
      + ' .text-in > h4,'
      + ' .text-in > h5,'
      + ' .text-in > ul,'
      + ' .text-in > ol,'
      + ' .text-in > .wp-caption,'
      + ' .text-in > blockquote',
      {
        id: 'slide_in',
        scroller: window.innerWidth > 767 ? '#app' : window,
        batchMax: window.innerWidth > 767 ? 15 : 5,
        interval: 0.2, // time window (in seconds) for batching to occur.
        onEnter: batch => gsap.to(batch, {
          duration: 2,
          ease: 'expo.out',
          x: 0, y: 0,
          rotation: 0,
          opacity: 1,
          stagger: 0.2,
          overwrite: true
        })
      });
  },

  playTheSplash() {
    if (!document.querySelector('.splash').classList.contains('done')) {
      const $video = document.querySelector('.splash video');

      $video.addEventListener('ended', (event) => {
        document.querySelector('.splash').classList.add('done');
        PubSub.publish('page.splashDone');
      });

      $video.play();
    }
  },

  destroySlideAnims() {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach(trigger => {
      if (trigger.vars.id === 'slide_in') {
        trigger.kill();
        console.log('Destroying slide_in triggers');
      }
    });

    ScrollTrigger.refresh();
  },

  destroy() {
    PubSub.unsubscribe('page.transitionStart', this.destroyBinded);
    PubSub.unsubscribe('common.resetSlideAnims', this.resetAnimsBinded);

    if (this.lscroll) {
      this.lscroll.destroy();
    }
    this.destroySlideAnims();
  }
};

PubSub.subscribe('page.inDOM', common.init.bind(common));

export default common;
